import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ForgotPasswordPageComponent } from '@app/auth/containers/forgot-password-request-page.component';
import { InformationPageComponent } from '@app/auth/containers/information-page.component';
import { LoginPageComponent } from '@app/auth/containers/login-page.component';
import { RegisterUserPageComponent } from '@app/auth/containers/register-user-page.component';
import { ResetPasswordPageComponent } from '@app/auth/containers/reset-password-page.component';
import { WelcomePageComponent } from '@app/auth/containers/welcome-page.component';
import { AuthGuard } from '@app/auth/guards/auth-guard.service';
import { ResetPasswordGuard } from '@app/auth/guards/reset-password-guard.service';
import { WelcomeGuard } from '@app/auth/guards/welcome-guard.service';

const routes: Routes = [
  { path: 'login', component: LoginPageComponent, canActivate: [WelcomeGuard] },
  { path: 'register', component: RegisterUserPageComponent },
  { path: 'forgotpassword', component: ForgotPasswordPageComponent },
  { path: 'resetpassword', component: ResetPasswordPageComponent, canActivate: [ResetPasswordGuard] },
  { path: 'information', component: InformationPageComponent },
  { path: 'welcome', component: WelcomePageComponent, canActivate: [AuthGuard] }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthRoutingModule {}
